import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/public/Humanising_static.png");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/app/assets/expertise-illustration.png");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/career/careers.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/contact/location.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/aboutContiner.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/AboutMap.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/accordianContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/container/brands.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/cardStack.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/caseStudiesCardStack.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/caseStudiesGrid.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/Faqs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/container/heroContainer.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/horizontalScrollContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/container/imageDescContainer.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/imageTextBannerContainer.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/imageTextBannerWithSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/container/introContainer.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/nestedSlider.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/pastAwards.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/pinnedSectionBk.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/relatedNews.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/servicesSlider.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/tabWithTableContent.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/textFloatImageContainer.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/videoTestimonial.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/workBanner.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/workflowScrollContainer.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/container/workResult.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/curves/bottomCurves.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/experiences/experienceGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/layout/csrNavCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs-sg/src/components/layout/preLoader.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/news/editor.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/news/news.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/revealElement.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/services/servicesOverview.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/uiDecor/bannerFloatingArrow.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/work/workList.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/corporate-nextjs-sg/src/components/work/works.tsx");
